const LoaderHome = () => {
  return (
    <div className="wrapper">
      <div className="wrapper-cell">
        <div className="image"></div>
        <div className="text">
            <div className="text-line"></div>
            <div className="text-line"></div>
            <div className="text-line"></div>
            <div className="text-line"></div>
        </div>
      </div>
    </div>
  );
};

export default LoaderHome;
